import React, { useEffect, useState, useRef } from 'react';
import { HashRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../INVENTORY/Assets/styles/addmenu.css';
import '../INVENTORY/Assets/styles/style.css';
import '../SalesTrading/Assets/Style/style.css';
import { getRole } from '../Redux/selecters/index';
import PlainLayout from '../POS/component/pages/SideBar/plainLayout';
// import Login from '../POS/component/pages/user/Login';
import Signup from '../POS/component/pages/user/signup';
import DashBoard from '../INVENTORY/Pages/dashBoard/dashboard';
import SaleOrder from '../SalesTrading/Pages/salesOrder/salesOrder';
import CreateSaleOrder from '../SalesTrading/Pages/salesOrder/createSaleOrder';
import { CurrencyProvider } from '../INVENTORY/Layouts/currencyContext';
import DRNListing from '../SalesTrading/Pages/DRN/DRNList';
import CreateDRN from '../SalesTrading/Pages/DRN/createDRN';
import CustomerInvoiceListing from '../SalesTrading/Pages/customerInvoice/customerInvoice';
import CreateCustomerInv from '../SalesTrading/Pages/customerInvoice/createCustomerInv';
import QuotationListing from '../SalesTrading/Pages/Quotation/quotationList';
import CreateQuotation from '../SalesTrading/Pages/Quotation/createQuotation';
import MainSalesLayout from '../SalesTrading/Layouts/mainLayout';
import QuotationView from '../SalesTrading/Pages/Quotation/quotationView';
import SalesInvoicePrint from '../SalesTrading/Pages/customerInvoice/print';
import SalesReturn from '../SalesTrading/Pages/salesReturn/salesReturn';
import SaleReturnCreate from '../SalesTrading/Pages/salesReturn/saleReturnCreate';
import QuotationPrint from '../SalesTrading/Pages/Quotation/print';
import SaleOrderPrint from '../SalesTrading/Pages/salesOrder/print';
import DNPrint from '../SalesTrading/Pages/DRN/print';
import SaleOrderView from '../SalesTrading/Pages/salesOrder/view';
import DnView from '../SalesTrading/Pages/DRN/view';
import CustomerInvView from '../SalesTrading/Pages/customerInvoice/invoiceview';
import Posting from '../SalesTrading/Pages/posting/posting';
import InventoryLogin from '../INVENTORY/Components/login/login';
import QuotationRevision from '../SalesTrading/Pages/Quotation/revision';
import SaleReturnPrint from '../SalesTrading/Pages/salesReturn/returnPrint';
import MainPMLayout from '../PropertyManagement/Layouts/mainLayout';
import PropertyDashBoard from '../PropertyManagement/Pages/dashboard/dashBoard';
import ProtectedRoute from '../PropertyManagement/Components/routesSetting/protectedRoutes';
import NoAccess from './noAccess';
import Dashboard from '../PropertyManagement/Pages/dashboard/customerPropertyDashboard';
import CustomerListing from '../PropertyManagement/Pages/customerMaster/listing';
import CustomerMaster from '../PropertyManagement/Pages/customerMaster/customerMaster';
import UpdateCustomerMaster from '../PropertyManagement/Pages/customerMaster/editCustomer';
import OccupancyReport from '../PropertyManagement/Pages/reports/occupancyReport';
import LeaseStatement from '../PropertyManagement/Pages/reports/leaseStatement';
import ReceiptLog from '../PropertyManagement/Pages/reports/receiptLog';
import ReceiptLogNarration from '../PropertyManagement/Pages/reports/receiptLogNarratoin';
import RevenueRental from '../PropertyManagement/Pages/reports/revenueRental';
import LeaseMoveInOut from '../PropertyManagement/Pages/reports/moveInOut';
import AgentCommission from '../PropertyManagement/Pages/agentCommission/agentCommission';
import LeaseBalancePayment from '../PropertyManagement/Pages/reports/balancePayment';
import LeaseExpiry from '../PropertyManagement/Pages/reports/leaseExpiry';
import RefundAnalysis from '../PropertyManagement/Pages/reports/refundAnalysis';
import AvailableUnitsLoss from '../PropertyManagement/Pages/reports/availableUnitLoss';
import LeaseInvoicePrint from '../PropertyManagement/Pages/reports/LeaseInvoicePrint';
import UnitVacantReport from '../PropertyManagement/Pages/reports/unitVacantReport';
import CustomerCurrentBalance from '../PropertyManagement/Pages/reports/customerCurrentBalance';
import AgentMasterListing from '../PropertyManagement/Pages/agentMaster/listing';
import BrokerMasterListing from '../PropertyManagement/Pages/brokerMaster/brokerMaster';
import PropertyListing from '../PropertyManagement/Pages/propertyMaster/listing';
import PropertyMasterCreate from '../PropertyManagement/Pages/propertyMaster/propertyCreate';
import UnitListing from '../PropertyManagement/Pages/unitMaster/listing';
import CreateUnitMaster from '../PropertyManagement/Pages/unitMaster/createUnit';
import UpdateUnitMaster from '../PropertyManagement/Pages/unitMaster/updateUnitMaster';
import PropertyMasterUpdate from '../PropertyManagement/Pages/propertyMaster/updateProperty';
import PropertyMasterView from '../PropertyManagement/Pages/propertyMaster/view';
import ViewUnitMaster from '../PropertyManagement/Pages/unitMaster/view';
import CommunityListing from '../PropertyManagement/Pages/communityMaster/listing';
import CreateCommunity from '../PropertyManagement/Pages/communityMaster/createCommunity';
import UpdateCommunity from '../PropertyManagement/Pages/communityMaster/updateCommunity';
import InstallmentInvoiceEmailListing from '../PropertyManagement/Pages/installmentInvoiceEmail/listing';
import UnitBlockListing from '../PropertyManagement/Pages/unitBlock/listing';
import UnitReleaseListing from '../PropertyManagement/Pages/unitBlock/releaseListing';
// Lease Agreement / Lease Renewal (ported from Qfinity-POS-Frontend-LeaseAggrement_k)
import LeaseListing from '../PropertyManagement/Pages/leaseAgreement/leaseListing';
import AddLeaseAgrement from '../PropertyManagement/Pages/leaseAgreement/addLease';
import AddLeaseAgrementView from '../PropertyManagement/Pages/leaseAgreement/leaseAggrementView';
import EditLeaseAgrement from '../PropertyManagement/Pages/leaseAgreement/editLease/editLease';
import LeaseAgreementRenew from '../PropertyManagement/Pages/leaseAgreement/leaseRenew/leaseRenew';
import RenewListing from '../PropertyManagement/Pages/leaseAgreement/leaseRenew/renewListing';

// Lease Proposal / Approvals / Termination / Invoices / Receipts / Posting /
// Inventory Update / Finance Posting (ported from Qfinity-POS-Frontend-LeaseAggrement_k)
import ProposalListing from '../PropertyManagement/Pages/leaseProposal/proposalListing';
import CreateLeaseProposal from '../PropertyManagement/Pages/leaseProposal/createLeaseProposal';
import EditLeaseProposal from '../PropertyManagement/Pages/leaseProposal/editProposal';
import ProposalView from '../PropertyManagement/Pages/leaseProposal/proposalView';
import ProposalApproval from '../PropertyManagement/Pages/leaseApproval/proposalApproval';
import AgreementApproval from '../PropertyManagement/Pages/leaseApproval/approval';
import InvoiceApprovalPage from '../PropertyManagement/Pages/leaseApproval/invoiceApproval';
import LeaseTerminationListing from '../PropertyManagement/Pages/leaseTermination/listing';
import LeaseTermination from '../PropertyManagement/Pages/leaseTermination/leaseTermination';
import SingleInvoiceListing from '../PropertyManagement/Pages/invoice/singleInvoiceListing';
import SingleInvoice from '../PropertyManagement/Pages/invoice/singleInvoice';
import InstallmentInvoiceListing from '../PropertyManagement/Pages/invoice/instalmentInvoiceListing';
import InstallmentInvoice from '../PropertyManagement/Pages/invoice/installmentInvoice';
import LeaseGeneralInvoiceListing from '../PropertyManagement/Pages/leaseGeneralInvoice/listing';
import LeaseGeneralInvoice from '../PropertyManagement/Pages/leaseGeneralInvoice/leaseGeneralInvoice';
import EditGeneralInvoice from '../PropertyManagement/Pages/leaseGeneralInvoice/editGeneralInvoice';
import LeaseReceiptListing from '../PropertyManagement/Pages/leaseReceipt/receiptListing';
import LeaseReceiptCreate from '../PropertyManagement/Pages/leaseReceipt/leaseReceipt';
import LeaseReceiptDashboard from '../PropertyManagement/Pages/leaseReceipt/leaseReceiptDashboard';
import BulkReceiptListing from '../PropertyManagement/Pages/bulkReceipt/bulkReceiptListing';
import BulkReceipt from '../PropertyManagement/Pages/bulkReceipt/bulkReceipt';
import ReverseReceipt from '../PropertyManagement/Pages/reverseReceipt/reverseReceipt';
import LeaseRevenuePosting from '../PropertyManagement/Pages/leaseRevenuePosting/leaseRevenue';
import InventoryUpdateList from '../PropertyManagement/Pages/inventoryUpdate/leaseList';
import JVImport from '../PropertyManagement/Pages/financePosting/jvImport';
import LeaseInvoiceImport from '../PropertyManagement/Pages/financePosting/leaseInvoiceImport';
import LeaseReceiptImport from '../PropertyManagement/Pages/financePosting/leaseReceiptImport';
import TaxStatementReport from '../PropertyManagement/Pages/reports/taxStatementReport';
import TenantInvoiceReport from '../PropertyManagement/Pages/reports/tenantInvoiceReport';
import TenantOccupancyReport from '../PropertyManagement/Pages/reports/tenantOccupancyReport';
import LeaseOutstandingReport from '../PropertyManagement/Pages/reports/leaseOutstandingReport';
import MonthWiseRevenueReport from '../PropertyManagement/Pages/reports/monthWiseRevenueReport';
import UnitMasterListReport from '../PropertyManagement/Pages/reports/unitMasterListReport';
import RevenueAgainstInvoicesReport from '../PropertyManagement/Pages/reports/revenueAgainstInvoicesReport';
import LeaseAgingAnalysisReport from '../PropertyManagement/Pages/reports/leaseAgingAnalysisReport';
import LeaseReceiptReport from '../PropertyManagement/Pages/reports/leaseReceiptReport';
import PdcListReport from '../PropertyManagement/Pages/reports/pdcListReport';
import AccruedRentReport from '../PropertyManagement/Pages/reports/accruedRentReport';
import OverstayDaysReport from '../PropertyManagement/Pages/reports/overstayDaysReport';

const AppRoutes = () => {
  const role = useSelector(getRole);
  const [userRole, setUserRole] = useState(role);
  const navigate = useNavigate();
  const permissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
  // const [permissions, setPermissions] = useState([]);

  // useEffect(() => {
  //   // const permissions = storedPermissions?.filter(acc => acc.formName === "Lease Receipt");
  //   setPermissions(storedPermissions);
  // }, [])
  return (
    <CurrencyProvider>
      <Routes>
        {!userRole && (
          <>
            {/* Customer routes */}
            <Route
              path="/login"
              element={
                <PlainLayout>
                  <InventoryLogin />
                </PlainLayout>
              }
            />
            <Route
              path="/signup"
              element={
                <PlainLayout>
                  <Signup />
                </PlainLayout>
              }
            />
          </>
        )}
        {/* <Route path="/" element={<MainSalesLayout><DashBoard /></MainSalesLayout>} /> */}
        <>
          {/* Sales Routes */}
          {/* Property Management */}
          <Route
            path="/"
            element={
              <MainPMLayout>
                <Dashboard />
              </MainPMLayout>
            }
          />
          <Route
            path="/listing"
            element={
              <MainPMLayout>
                <PropertyDashBoard />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Customer/Listing"
            element={
              <MainPMLayout>
                <CustomerListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Customer/Create"
            element={
              <MainPMLayout>
                <CustomerMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Customer/Update"
            element={
              <MainPMLayout>
                <UpdateCustomerMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Agent/Listing"
            element={
              <MainPMLayout>
                <AgentMasterListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Broker/Listing"
            element={
              <MainPMLayout>
                <BrokerMasterListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Property/Listing"
            element={
              <MainPMLayout>
                <PropertyListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Property/Create"
            element={
              <MainPMLayout>
                <PropertyMasterCreate />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Property/Update"
            element={
              <MainPMLayout>
                <PropertyMasterUpdate />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Property/view"
            element={
              <MainPMLayout>
                <PropertyMasterView />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Property/listing"
            element={
              <MainPMLayout>
                <PropertyListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/Listing"
            element={
              <MainPMLayout>
                <UnitListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/listing"
            element={
              <MainPMLayout>
                <UnitListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/Create"
            element={
              <MainPMLayout>
                <CreateUnitMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/Update"
            element={
              <MainPMLayout>
                <UpdateUnitMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/view"
            element={
              <MainPMLayout>
                <ViewUnitMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Community/Listing"
            element={
              <MainPMLayout>
                <CommunityListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Community/Create"
            element={
              <MainPMLayout>
                <CreateCommunity />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Community/Update/:recordId"
            element={
              <MainPMLayout>
                <UpdateCommunity />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/UnitBlock/Listing"
            element={
              <MainPMLayout>
                <UnitBlockListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/UnitRelease/Listing"
            element={
              <MainPMLayout>
                <UnitReleaseListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/InstallmentInvoiceEmail/Listing"
            element={
              <MainPMLayout>
                <InstallmentInvoiceEmailListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Occupancy"
            element={
              <MainPMLayout>
                <OccupancyReport />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Lease_Statement"
            element={
              <MainPMLayout>
                <LeaseStatement />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Receipt-log"
            element={
              <MainPMLayout>
                <ReceiptLog />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Receipt-log_Narration"
            element={
              <MainPMLayout>
                <ReceiptLogNarration />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Revenue_Rental"
            element={
              <MainPMLayout>
                <RevenueRental />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Move_IN_OUT"
            element={
              <MainPMLayout>
                <LeaseMoveInOut />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/LeaseExpiry"
            element={
              <MainPMLayout>
                <LeaseExpiry />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/RefundAnalysis"
            element={
              <MainPMLayout>
                <RefundAnalysis />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/RevenueLoss"
            element={
              <MainPMLayout>
                <AvailableUnitsLoss />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/UnitVacant"
            element={
              <MainPMLayout>
                <UnitVacantReport />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/CustomerCurrentBalance"
            element={
              <MainPMLayout>
                <CustomerCurrentBalance />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Lease/Agent/Commission"
            element={
              <MainPMLayout>
                <AgentCommission />
              </MainPMLayout>
            }
          />
          {/* Lease Agreement (ported) — Add/Edit/View/Renew all open as popups from the listing page */}
          <Route
            path="/Lease/Management/Lease/Agreement/Listing"
            element={
              <MainPMLayout>
                <LeaseListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Lease/Agreement/Create"
            element={
              <MainPMLayout>
                <AddLeaseAgrement />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Lease/Agreement/:id"
            element={
              <MainPMLayout>
                <AddLeaseAgrementView />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Lease/Agreement/edit/:id"
            element={
              <MainPMLayout>
                <EditLeaseAgrement />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Lease/Agreement/renew/:id"
            element={
              <MainPMLayout>
                <LeaseAgreementRenew />
              </MainPMLayout>
            }
          />
          {/* Lease Renewal (ported) */}
          <Route
            path="/Lease/Management/Lease/Renewal/Listing"
            element={
              <MainPMLayout>
                <RenewListing />
              </MainPMLayout>
            }
          />

          {/* Lease Proposal / Lease Approval (ported) */}
          <Route path="/Lease/Management/Proposal/Listing" element={<MainPMLayout><ProposalListing /></MainPMLayout>} />
          <Route path="/Lease/Management/Proposal/Add" element={<MainPMLayout><CreateLeaseProposal /></MainPMLayout>} />
          <Route path="/Lease/Management/Proposal/Edit/:id" element={<MainPMLayout><EditLeaseProposal /></MainPMLayout>} />
          <Route path="/Lease/Management/Proposal/:id" element={<MainPMLayout><ProposalView /></MainPMLayout>} />
          <Route path="/Lease/Management/Proposal/Approval" element={<MainPMLayout><ProposalApproval /></MainPMLayout>} />

          {/* Agreement Approval (ported) */}
          <Route path="/Lease/Management/Agreement/Approval" element={<MainPMLayout><AgreementApproval /></MainPMLayout>} />

          {/* Lease Termination (ported) */}
          <Route path="/Lease/Management/Termination/Listing" element={<MainPMLayout><LeaseTerminationListing /></MainPMLayout>} />
          <Route path="/Lease/Management/Termination" element={<MainPMLayout><LeaseTermination /></MainPMLayout>} />

          {/* Invoices: Single / Installment / Invoice Approval / Lease General Invoice (ported) */}
          <Route path="/Lease/Management/Invoice/Single/Listing" element={<MainPMLayout><SingleInvoiceListing /></MainPMLayout>} />
          <Route path="/Lease/Management/Invoice/Single" element={<MainPMLayout><SingleInvoice /></MainPMLayout>} />
          <Route path="/Lease/Management/Invoice/Installment/Listing" element={<MainPMLayout><InstallmentInvoiceListing /></MainPMLayout>} />
          <Route path="/Lease/Management/Invoice/Installment" element={<MainPMLayout><InstallmentInvoice /></MainPMLayout>} />
          <Route path="/Lease/Management/Invoice/Approval" element={<MainPMLayout><InvoiceApprovalPage /></MainPMLayout>} />
          <Route path="/Lease/Management/Invoice/General/Listing" element={<MainPMLayout><LeaseGeneralInvoiceListing /></MainPMLayout>} />
          <Route path="/Lease/Management/Invoice/General" element={<MainPMLayout><LeaseGeneralInvoice /></MainPMLayout>} />
          <Route path="/Lease/Management/Invoice/General/Edit/:id" element={<MainPMLayout><EditGeneralInvoice /></MainPMLayout>} />

          {/* Receipts: Lease Receipt / Bulk Receipt / Reverse Receipt (ported) */}
          <Route path="/Lease/Management/Receipt/Listing" element={<MainPMLayout><LeaseReceiptListing /></MainPMLayout>} />
          <Route path="/Lease/Management/Receipt/Create" element={<MainPMLayout><LeaseReceiptCreate /></MainPMLayout>} />
          <Route path="/Lease/Management/Receipt/:id" element={<MainPMLayout><LeaseReceiptDashboard /></MainPMLayout>} />
          <Route path="/Lease/Management/Receipt/Bulk/Listing" element={<MainPMLayout><BulkReceiptListing /></MainPMLayout>} />
          <Route path="/Lease/Management/Receipt/Bulk" element={<MainPMLayout><BulkReceipt /></MainPMLayout>} />
          <Route path="/Lease/Management/Receipt/Reverse" element={<MainPMLayout><ReverseReceipt /></MainPMLayout>} />

          {/* Posting: Lease Revenue Posting (ported) */}
          <Route path="/Lease/Management/Posting/Revenue" element={<MainPMLayout><LeaseRevenuePosting /></MainPMLayout>} />

          {/* Inventory Update (ported) */}
          <Route path="/Lease/Management/Inventory/Update" element={<MainPMLayout><InventoryUpdateList /></MainPMLayout>} />

          {/* Finance Posting: JV Import / Lease Invoice Import / Lease Receipt Import (ported) */}
          <Route path="/Lease/Management/FinancePosting/JVImport" element={<MainPMLayout><JVImport /></MainPMLayout>} />
          <Route path="/Lease/Management/FinancePosting/InvoiceImport" element={<MainPMLayout><LeaseInvoiceImport /></MainPMLayout>} />
          <Route path="/Lease/Management/FinancePosting/ReceiptImport" element={<MainPMLayout><LeaseReceiptImport /></MainPMLayout>} />

          {/* Reports (ported) - Available Units/Occupancy/Lease Statement/Move In-Out
              reuse the existing routes above (Report/Occupancy, Report/Lease_Statement,
              Report/Move_IN_OUT) since only their underlying page content was replaced */}
          <Route path="/Lease/Management/Report/TaxStatement" element={<MainPMLayout><TaxStatementReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/TenantInvoice" element={<MainPMLayout><TenantInvoiceReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/TenantOccupancy" element={<MainPMLayout><TenantOccupancyReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/LeaseOutstanding" element={<MainPMLayout><LeaseOutstandingReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/MonthWiseRevenue" element={<MainPMLayout><MonthWiseRevenueReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/UnitMasterList" element={<MainPMLayout><UnitMasterListReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/RevenueAgainstInvoices" element={<MainPMLayout><RevenueAgainstInvoicesReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/AgingAnalysis" element={<MainPMLayout><LeaseAgingAnalysisReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/LeaseReceipts" element={<MainPMLayout><LeaseReceiptReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/PDCList" element={<MainPMLayout><PdcListReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/AccruedRent" element={<MainPMLayout><AccruedRentReport /></MainPMLayout>} />
          <Route path="/Lease/Management/Report/OverstayDays" element={<MainPMLayout><OverstayDaysReport /></MainPMLayout>} />
        </>
      </Routes>
    </CurrencyProvider>
  );
};

export default AppRoutes;
